<template>
  <div class="animated fadeIn" @keyup.enter="onFilter">
    <div class="form-group row">
      <div class="col-md-12">
        <label> Código:</label>
        <div class="input-group">
          <b-form-input type="text"
                        :placeholder="'Digite o código do Produto'"
                        v-model="form.codigo.value"
                        :state="form.codigo.state"
                        autofocus
          />
        </div>
      </div>
      <div class="col-md-12 pt-3 pb-3">
        <label> Nome:</label>
        <div class="input-group">
          <b-form-input type="text"
                        :placeholder="'Digite o nome do Produto'"
                        v-model="form.nome.value"
                        :state="form.nome.state"
                        autofocus
          />
        </div>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-md-12 pt-2">
        <button type="button" class="btn btn-third w-100" v-on:click="onFilter">Filtrar</button>
      </div>
      <div class="col-md-12 pt-2">
        <button type="button" class="btn btn-default w-100" v-on:click="onClearFilters">Limpar Filtros</button>
      </div>
    </div>
    <div class="form-group row" style="margin-top: 250px;">&nbsp;<!--Space to scroll--></div>
  </div>
</template>
<script>

import PaSearch from './search.js'
export default PaSearch

</script>



// WEBPACK FOOTER //
// src/views/private/configurations/product/components/search/search.vue